module.exports = __webpack_public_path__ + "img/Web-Dilbar-Charl-van-Rooy-97918.jpg";